module.exports = __webpack_public_path__ + "img/icon-2.6a3af4a9.png";